var _defs, _path, _path2, _path3, _polyline, _path4, _line, _line2, _line3, _line4, _line5, _line6, _path5, _path6, _line7, _line8, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".step-location-1,.step-location-2{fill:none;stroke-miterlimit:10;stroke-width:0.75px;}.step-location-1{stroke:#58595b;stroke-linecap:round;}.step-location-2{stroke:#5e5e5e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "step-location-1",
    d: "M18.36,24.45V6.55A4.75,4.75,0,0,1,23.11,1.8H35.37a4.74,4.74,0,0,1,4.75,4.75V9.27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "step-location-1",
    d: "M40.12,12.08V32.66a4.74,4.74,0,0,1-4.75,4.74H23.11a4.72,4.72,0,0,1-2.79-.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "step-location-1",
    d: "M24.15,1.8H34.43a0,0,0,0,1,0,0V2a3.31,3.31,0,0,1-3.31,3.31H27.46A3.31,3.31,0,0,1,24.15,2V1.8A0,0,0,0,1,24.15,1.8Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "step-location-1",
    points: "27.26 26.97 35.52 26.97 35.52 31.07 25.58 31.07"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "step-location-1",
    d: "M16.34,31.23l4.86-4.85a2.05,2.05,0,0,1,2.9,0l.18.18a2.05,2.05,0,0,1,0,2.9L20.14,33.6"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "step-location-1",
    x1: 9.07,
    y1: 47.59,
    x2: 9.07,
    y2: 34.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "step-location-1",
    x1: 8.99,
    y1: 47.59,
    x2: 9.07,
    y2: 47.59
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "step-location-1",
    x1: 8.99,
    y1: 34.3,
    x2: 8.99,
    y2: 47.59
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "step-location-1",
    x1: 9.07,
    y1: 34.3,
    x2: 8.99,
    y2: 34.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "step-location-1",
    x1: 17.97,
    y1: 42.75,
    x2: 17.97,
    y2: 47.71
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "step-location-1",
    x1: 20.04,
    y1: 33.6,
    x2: 20.04,
    y2: 38.27
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "step-location-1",
    d: "M11.53,29.54A7.32,7.32,0,0,0,9,34.16"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "step-location-1",
    d: "M18,42.61a7.86,7.86,0,0,0,1.25-1.67A7.1,7.1,0,0,0,20,38.41"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "step-location-1",
    x1: 15.68,
    y1: 24.93,
    x2: 13.37,
    y2: 27.46
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "step-location-1",
    x1: 18.66,
    y1: 24.93,
    x2: 15.82,
    y2: 24.93
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "step-location-2",
    d: "M25,19.62a5.81,5.81,0,0,1-1.82-4.13,5.72,5.72,0,0,1,5.67-5.74,5.64,5.64,0,0,1,3,.8l-1.78,1.84c-.06,0-.65-.13-1.29-.12a3.17,3.17,0,1,0,3.21,3.17,2.54,2.54,0,0,0,0-.39l-.94,1a1.26,1.26,0,0,1-.69.37,1,1,0,0,1-.93-.35,1.06,1.06,0,0,1,0-1.47l3.28-3.28a5.69,5.69,0,0,1,0,8.32c-.1.09-3.17,3.17-3.17,3.17a1,1,0,0,1-1.39,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepLocation);
export default __webpack_public_path__ + "static/media/step-location.6a3faa3a.svg";
export { ForwardRef as ReactComponent };